import { render, staticRenderFns } from "./sieveSingleCenter.vue?vue&type=template&id=d0160888&"
import script from "./sieveSingleCenter.vue?vue&type=script&lang=js&"
export * from "./sieveSingleCenter.vue?vue&type=script&lang=js&"
import style0 from "./sieveSingleCenter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports